import { yupResolver } from '@hookform/resolvers/yup';
import AddIcon from '@mui/icons-material/Add';
import { Button, Stack } from '@mui/material';
import PageHeaderText from 'layout/pages/PageHeaderText';
import PageHeaderWrapper from 'layout/pages/PageHeaderWrapper';
import { isNil } from 'lodash';
import { useContext } from 'react';
import { FormContainer, TextFieldElement, useForm } from 'react-hook-form-mui';
import StoreContext from 'stores/context/StoreContext';
import { object, string } from 'yup';
import type { ReactNode } from 'react';
import type { SubmitHandler } from 'react-hook-form-mui';

interface UsersFilterData {
  search: string;
}

export interface UsersPageHeaderProps {
  searchTextInit?: string;
  onSearchChanged?: (text: string) => void;
  onCreateClick?: VoidFunction;
  filterButton?: ReactNode; // Add new prop for filter button
}

export default function UsersPageHeader({
  onSearchChanged,
  onCreateClick,
  searchTextInit,
  filterButton, // Add new prop
}: UsersPageHeaderProps): JSX.Element {
  const { notifyStore } = useContext(StoreContext);

  const schema = object<UsersFilterData>({
    search: string().max(300),
  }).required();

  const formContext = useForm<UsersFilterData>({
    mode: 'onChange',
    defaultValues: {
      search: searchTextInit ?? '',
    },
    resolver: yupResolver(schema),
  });

  onCreateClick =
    onCreateClick ??
    (() => {
      notifyStore.showNotify('Ничего не произошло', 'info');
    });

  const filter: SubmitHandler<UsersFilterData> = (data) => {
    !isNil(onSearchChanged) && onSearchChanged(data.search);
  };

  return (
    <PageHeaderWrapper>
      <PageHeaderText align='center' text='Сотрудники' />
      <Stack spacing={1} direction='row' alignItems='center'>
        <FormContainer
          FormProps={{ style: { flexGrow: 1 } }}
          formContext={formContext}
          onSuccess={filter}>
          <TextFieldElement
            size='small'
            fullWidth
            name='search'
            placeholder='Поиск: ФИО, Телефон'
            type='search'
          />
        </FormContainer>
        {filterButton} {/* Add filter button */}
        <Button startIcon={<AddIcon />} onClick={onCreateClick} variant='contained'>
          Создать
        </Button>
      </Stack>
    </PageHeaderWrapper>
  );
}
